<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.provider_data") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #f7941e">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Establishment Data Section -->
          <div class="col-12">
            <h3 class="section_title mb-4">
              <i class="fal fa-building mr-2"></i>
              {{ $t("PLACEHOLDERS.establishment_data") }}
            </h3>
          </div>

          <!-- Logo -->
          <div class="col-12 mb-3">
            <div class="text-center">
              <label class="detail_label d-block mb-3">{{
                $t("PLACEHOLDERS.establishment_logo")
              }}</label>
              <div class="logo_container">
                <img
                  v-if="data.logo"
                  :src="data.logo"
                  :alt="$t('PLACEHOLDERS.establishment_logo')"
                  class="establishment_logo"
                />
                <div v-else class="no_logo">
                  <i class="fal fa-image"></i>
                  <p>{{ $t("TABLES.noData") }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Establishment Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.establishment_name')"
            v-model="data.establishment_name"
            disabled
          />

          <!-- Commercial Registration Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commercial_registration_number')"
            v-model="data.commercial_registration"
            disabled
          />

          <!-- Number of Branches -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.number_of_branches')"
            v-model="data.branches_count"
            disabled
          />

          <!-- Joining Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.joining_date')"
            v-model="data.joining_date"
            disabled
          />

          <!-- Start:: Manager Data Section -->
          <div class="col-12 mt-4">
            <h3 class="section_title mb-4">
              <i class="fal fa-user-tie mr-2"></i>
              {{ $t("PLACEHOLDERS.manager_data") }}
            </h3>
          </div>

          <!-- Full Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.full_name')"
            v-model="data.manager_name"
            disabled
          />

          <!-- ID Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.identity_number')"
            v-model="data.manager_id_number"
            disabled
          />

          <!-- Mobile Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model="data.manager_mobile"
            disabled
          />

          <!-- Email -->
          <base-input
            col="6"
            type="email"
            :placeholder="$t('PLACEHOLDERS.sender_email')"
            v-model="data.manager_email"
            disabled
          />

          <!-- Start:: Platform Activity Section -->
          <div class="col-12 mt-4">
            <h3 class="section_title mb-4">
              <i class="fal fa-chart-line mr-2"></i>
              {{ $t("PLACEHOLDERS.platform_activity") }}
            </h3>
          </div>

          <!-- Created Ads Count -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_ads_count')"
            v-model="data.created_ads_count"
            disabled
          />

          <!-- Published Ads Count -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.published_ads_count')"
            v-model="data.published_ads_count"
            disabled
          />

          <!-- Expired Ads Count -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.expired_ads_count')"
            v-model="data.expired_ads_count"
            disabled
          />

          <!-- Total Attendees -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.total_attendees')"
            v-model="data.total_attendees"
            disabled
          />

          <!-- Total Platform Payments -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.total_platform_payments')"
            v-model="data.total_payments"
            disabled
          />
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowProvider",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection
      data: {
        // Establishment Data
        logo: null,
        establishment_name: null,
        commercial_registration: null,
        branches_count: null,
        joining_date: null,

        // Manager Data
        manager_name: null,
        manager_id_number: null,
        manager_mobile: null,
        manager_email: null,

        // Platform Activity Data
        created_ads_count: null,
        published_ads_count: null,
        expired_ads_count: null,
        total_attendees: null,
        total_payments: null,
      },
      // End:: Data Collection
    };
  },

  methods: {
    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers/${this.$route.params.id}`,
        });

        const providerData = res.data.data.Provider;

        // Establishment Data - Get logo from media collection
        const providerImage = providerData.media?.find(
          (m) => m.collection_name === "provider-image"
        );
        this.data.logo = providerImage?.original_url || providerData.image;
        this.data.establishment_name = providerData.name || null;
        this.data.commercial_registration = providerData?.provider_details.commercial_register || null;
        this.data.branches_count =
          providerData.provider_details.branches_count || 0; // Not available in the response
        this.data.joining_date =
          providerData.joined_at || providerData.created_at;

        // Manager Data
        this.data.manager_name = providerData.name;
        this.data.manager_id_number = providerData.nationalId;
        this.data.manager_mobile = providerData.mobile;
        this.data.manager_email = providerData.email;

        // Platform Activity Data
        this.data.created_ads_count =
          providerData.total_announcement_count || 0;
        this.data.published_ads_count =
          providerData.published_announcement_count || 0;
        this.data.expired_ads_count =
          providerData.finished_announcement_count || 0;
        this.data.total_attendees = providerData.joined_users || 0;
        this.data.total_payments = providerData.total_payed || 0;
      } catch (error) {
        this.$message.error(
          error.response?.data?.message ||
            this.$t("MESSAGES.error_fetching_data")
        );
      }
    },
    // End:: Get Data To Show
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToShow();
    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.section_title {
  color: #28877b;
  font-size: 1.4rem;
  font-weight: 600;
  border-bottom: 2px solid #28877b;
  padding-bottom: 12px;

  i {
    color: #28877b;
  }
}

.detail_label {
  font-weight: 600;
  color: #555;
  font-size: 0.95rem;
  margin-bottom: 8px;
  display: block;
}

.logo_container {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.establishment_logo {
  max-width: 200px;
  max-height: 200px;
  object-fit: contain;
  border-radius: 12px;
  border: 2px solid #e0e0e0;
  padding: 10px;
  background: #fff;
}

.no_logo {
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f8f9fa;
  border: 2px dashed #ccc;
  border-radius: 12px;
  color: #999;

  i {
    font-size: 3rem;
    margin-bottom: 10px;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
  }
}

@media (max-width: 767px) {
  .section_title {
    font-size: 1.2rem;
  }

  .establishment_logo {
    max-width: 150px;
    max-height: 150px;
  }

  .no_logo {
    width: 150px;
    height: 150px;
  }
}
</style>
